

import React, { useCallback, useEffect, useState, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import {
  Row,
  Col,
  Spin,
  Card,
  Table,
  Button,
  Input,
  AutoComplete,
  notification,
  Modal,
  Select,
  Avatar,
  Typography,
  TableColumnsType,
  Checkbox,
  DatePicker,
  Drawer,
  Descriptions,  // ADD THIS
  Tag,           // ADD THIS
  Space,         // ADD THIS
  Tooltip,       // ADD THIS
  Alert,         // ADD THIS
} from "antd";
import axios from "axios";
import { baseUrl } from "../../config";
import {
  DeleteOutlined,
  FileExcelOutlined,
  FilterOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  SearchOutlined,
  EyeOutlined,
  StopOutlined,
  CheckCircleOutlined,
  UserOutlined,
  StarFilled,
  TrophyFilled,
  PlusCircleOutlined,
  EnvironmentOutlined,
} from "@ant-design/icons";
import userDummy from "../../assets/images/dummy-user.png";
import { getPermissions, hasPermission } from "../../components/permissions";
import "../../assets/styles/custom_style.css";
import moment from "moment";
import AddUserDetailsModel from "../sn_payments/AddUserDetailsModel";
import * as XLSX from "xlsx";

// Loyalty badge config by years active
const getLoyaltyBadge = (years) => {
  if (!years || years < 1) return null;
  if (years >= 10) return { label: `${years}yr`, color: '#722ed1', bg: '#f9f0ff', title: `💎 Lifetime Member — ${years} years of contribution` };
  if (years >= 5)  return { label: `${years}yr`, color: '#d4a017', bg: '#fffbe6', title: `🥇 Veteran Member — ${years} years of contribution` };
  if (years >= 3)  return { label: `${years}yr`, color: '#8c8c8c', bg: '#f5f5f5', title: `🥈 Senior Member — ${years} years of contribution` };
  return            { label: `${years}yr`, color: '#8B4513', bg: '#fdf6ec', title: `🥉 Member — ${years} years of contribution` };
};


const { confirm } = Modal;
const { Search } = Input;
const { Option } = Select;
const { Title, Text } = Typography; 

const createStyledTitle = (text) => (
  <span style={{ fontSize: "13px", color: "#374151", fontWeight: 700 }}>{text}</span>
);




function UsersList() {
  const history = useHistory();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const currentPageQuery = parseInt(queryParams.get("page")) || 1;
  const limitQuery = parseInt(queryParams.get("limit")) || 20;
  const [paymentList, setPaymentList] = useState([]);
  const [pagination, setPagination] = useState({});
  const [currentPage, setCurrentPage] = useState(currentPageQuery);
  const [limit, setLimit] = useState(limitQuery);
  const [loading, setLoading] = useState(false); // State to manage the loade
  const [userList, setUserList] = useState([]);

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [search, setSearch] = useState("");
  const [staffList, setStaffList] = useState([]);

  const [filters, setFilters] = useState({
    name: queryParams.get("name") || "",
    email: queryParams.get("email") || "",
    phone: queryParams.get("phone") || "",
    father_name: queryParams.get("father_name") || "",
    gotra: queryParams.get("gotra") || "",
    kuldevi: queryParams.get("kuldevi") || "",
    kulrishi: queryParams.get("kulrishi") || "",
    alternate_phone_no: queryParams.get("alternate_phone_no") || "",
    alternate_phone_no2: queryParams.get("alternate_phone_no2") || "",
    category: queryParams.get("category") || "",
    dob: queryParams.get("dob") || "",
    joining_date: queryParams.get("joining_date") || "",
    min_monthly_amount: queryParams.get("min_monthly_amount") || "",
    max_monthly_amount: queryParams.get("max_monthly_amount") || "",
    status: queryParams.get("status") || "",
    maritial_status: queryParams.get("maritial_status") || "",
    relation_hn: queryParams.get("relation_hn") || "",

    per_village_en: queryParams.get("per_village_en") ? queryParams.get("per_village_en").split(',').filter(Boolean) : [],
    per_post_en: queryParams.get("per_post_en") || "",
    per_tahsil_en: queryParams.get("per_tahsil_en") ? queryParams.get("per_tahsil_en").split(',').filter(Boolean) : [],
    per_pin_code_en: queryParams.get("per_pin_code_en") || "",
    per_district_en: queryParams.get("per_district_en") ? queryParams.get("per_district_en").split(',').filter(Boolean) : [],
    per_state_en: queryParams.get("per_state_en") || "",
    per_country_en: queryParams.get("per_country_en") || "",

    txn_tem_address_en: queryParams.get("txn_tem_address_en") || "",
    tem_village_en: queryParams.get("tem_village_en") || "",
    tem_street_en: queryParams.get("tem_street_en") || "",
    tem_city_en: queryParams.get("tem_city_en") || "",
    tem_pin_code_en: queryParams.get("tem_pin_code_en") || "",
    tem_district_en: queryParams.get("tem_district_en") || "",
    tem_state_en: queryParams.get("tem_state_en") || "",
    tem_country_en: queryParams.get("tem_country_en") || "",
  });
  

  useEffect(() => {
    const { state } = history.location; // Get the state from history
    const restoredPage = state?.page || currentPage; // Restore page from state or use current page
    const restoredLimit = state?.limit || limit; // Restore limit from state or use current limit

    // Call getUserList with restored page and limit
    getUserList(
      restoredPage,
      restoredLimit,
      sortField,
      sortOrder,
      search,
      filters
    );
  }, [history.location]);

  async function getStaffList() {
    try {
      const response = await axios.get(`${baseUrl}/staff/list`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.data.status) {
        setStaffList(response.data.result);
      } else {
        notification.info({
          message: "Info",
          description: response.data.message,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: "Info",
        description: error.response?.data?.message,
        placement: "topRight",
      });
    }
  }

  const debounce = (func, delay) => {
    let debounceTimer;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => func.apply(context, args), delay);
    };
  };

  async function getUserList(
    page = 1,
    limit = 20,
    sortField = null,
    sortOrder = null,
    search = "",
    filters = {}
  ) {
    try {
      setCurrentPage(page);
      setLimit(limit);
      const sortParam =
        sortField && sortOrder
          ? `&sortField=${sortField}&sortOrder=${sortOrder}`
          : "";
      const searchParam = search ? `&search=${search}` : "";
      const filterParams = Object.keys(filters)
        .map((key) => `${key}=${filters[key]}`)
        .join("&");
      const response = await axios.get(
        `${baseUrl}/users/list?page=${page}&limit=${limit}${sortParam}${searchParam}&${filterParams}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        }
      );
      if (response.data.status) {
        setUserList(response.data.result);
        setPagination({
          current: page,
          pageSize: limit,
          total: response.data.totalCount,
        });
      } else {
        notification.info({
          message: "Info",
          description: response.data.message,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: "Info",
        description: error.response?.data?.message,
        placement: "topRight",
      });
    }
  }

  async function handleDelete(id) {
    try {
      const response = await axios.delete(`${baseUrl}/users/delete/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.status === 200) {
        getUserList(
          pagination.current,
          pagination.pageSize,
          sortField,
          sortOrder,
          search,
          filters
        );
        notification.success({
          message: "Success",
          description: "User deleted successfully!",
          placement: "topRight",
        });
      } else {
        notification.info({
          message: "Info",
          description: response.data.message,
          placement: "topRight",
        });
      }
    } catch (error) {
      console.error("API error:", error);
      notification.info({
        message: "Info",
        description: error.response?.data?.message,
        placement: "topRight",
      });
    }
  }


  const handleToggleLeaderboard = async (id, currentHidden) => {
    try {
      const res = await axios.patch(`${baseUrl}/admin/users/${id}/leaderboard-visibility`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
      });
      if (res.data.status) {
        notification.success({ message: res.data.message, placement: 'topRight' });
        handleSearchReport();
      } else {
        notification.error({ message: res.data.message || 'Error', placement: 'topRight' });
      }
    } catch {
      notification.error({ message: 'Could not update leaderboard visibility', placement: 'topRight' });
    }
  };

  const handleToggleBlockMsg = async (id, currentVal) => {
    const newVal = currentVal ? 0 : 1;
    try {
      await axios.patch(`${baseUrl}/users/${id}/block-msg`, { block_msg: newVal }, {
        headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
      });
      notification.success({ message: newVal ? "User blocked from all messages." : "User unblocked.", placement: "topRight" });
      getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
    } catch (err) {
      notification.error({ message: "Failed: " + err.message, placement: "topRight" });
    }
  };

  const showPermanentDeleteConfirm = (id, name) => {
    confirm({
      title: `Permanently delete "${name}"?`,
      icon: <ExclamationCircleOutlined />,
      content: "This will remove the user and all linked records (address, occupation, message logs). Payments will be kept but unlinked. This CANNOT be undone.",
      okText: "Permanently Delete",
      okType: "danger",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          const res = await axios.delete(`${baseUrl}/users/permanent-delete/${id}`, {
            headers: { Authorization: `Bearer ${localStorage.getItem("accessToken")}` },
          });
          if (res.data.status) {
            notification.success({ message: res.data.message, placement: "topRight" });
            getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
          } else {
            notification.error({ message: res.data.message, placement: "topRight" });
          }
        } catch (err) {
          notification.error({ message: err.response?.data?.message || err.message, placement: "topRight" });
        }
      },
    });
  };

  const handleDetachParent = (id, name) => {
    confirm({
      title: `Make "${name}" a standalone parent member?`,
      icon: <ExclamationCircleOutlined />,
      content: 'This will remove the parent link and make this user an independent (parent-level) member.',
      okText: 'Yes, Detach',
      okType: 'primary',
      cancelText: 'Cancel',
      async onOk() {
        try {
          const response = await axios.patch(`${baseUrl}/users/detach-parent/${id}`, {}, {
            headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
          });
          if (response.data.status) {
            notification.success({ message: 'Success', description: response.data.message, placement: 'topRight' });
            getUserList(pagination.current, pagination.pageSize, sortField, sortOrder, search, filters);
          } else {
            notification.error({ message: 'Error', description: response.data.message, placement: 'topRight' });
          }
        } catch (err) {
          notification.error({ message: 'Error', description: err.response?.data?.message || 'Failed to detach parent.', placement: 'topRight' });
        }
      },
    });
  };

  const handleTableChange = (pagination, _antFilters, sorter) => {
    const { current, pageSize } = pagination;
    const { field, order } = sorter;
    const formattedOrder = order === "ascend" ? "asc" : "desc";
    setSortField(field);
    setSortOrder(formattedOrder);
    // Do NOT call setFilters here — _antFilters is Ant Design's column filter object
    // (always empty since we use custom filter inputs), and would wipe out the user's search

    history.push(`?page=${current}&limit=${pageSize}`);
    getUserList(current, pageSize, field, formattedOrder, search, filters);
  };

  const handleSearch = (value) => {
    setSearch(value);
    getUserList(currentPage, limit, sortField, sortOrder, value, filters);
  };

  const handleLimitChange = (value) => {
    setLimit(value);

    // Update URL with the new limit and reset page to 1
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set("limit", value);
    updatedQueryParams.set("page", 1); // Reset to first page whenever limit changes

    // Push new URL with updated query params
    history.push(`?${updatedQueryParams.toString()}`);

    // Call the API to fetch data with updated limit
    getUserList(1, value); // Assuming your API call accepts page and limit
  };

  const debouncedGetUserList = useCallback(
    debounce((page, limit, sortField, sortOrder, search, filters) => {
      getUserList(page, limit, sortField, sortOrder, search, filters);
    }, 300),
    []
  );

  const handleFilterChange2 = (field, value) => {
    const newFilters = {
      ...filters,
      [field]: value,
    };
    setFilters(newFilters);

    // Update URL with new filters
    const updatedQueryParams = new URLSearchParams(location.search);
    updatedQueryParams.set("page", 1); // Reset to first page when filters change
    Object.keys(newFilters).forEach((key) => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key); // Remove empty filters from the URL
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);

    // Trigger a new API call
    getUserList(1, limit, newFilters);
  };

  const handleFilterChange = (field, value, searchMode = false) => {
    const newFilters = { ...filters, [field]: value };
    setFilters(newFilters);

    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(newFilters).forEach((key) => {
      if (newFilters[key]) {
        updatedQueryParams.set(key, newFilters[key]);
      } else {
        updatedQueryParams.delete(key);
      }
    });
    history.push(`?${updatedQueryParams.toString()}`);

    if (searchMode === true) {
      getUserList(1, limit, sortField, sortOrder, search, newFilters);
    } else if (searchMode === 'debounced') {
      debouncedGetUserList(1, limit, sortField, sortOrder, search, newFilters);
    }
  };

  const [showUserFilter, setShowUserFilter] = useState(true);
  const [showPermanentAddress, setShowPermanentAddress] = useState(false);
  const [showTemporaryAddress, setShowTemporaryAddress] = useState(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

  const labelStyle = {
    fontSize: '13px',
    color: '#000',
    display: 'block',
    marginBottom: '4px',
    fontWeight: 500,
    height: '16px',
    lineHeight: '16px',
  };





  //For show image on model larges
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentImage, setCurrentImage] = useState("");

  const showModal = (image) => {
    setCurrentImage(image || userDummy);
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const [AddUserDetailsFormModel, setAddUserDetailsModel] = useState(false);
  const [userBasicDetail, setuserBasicDetail] = useState({}); // state to store the selected file

  const [AddEditUserDetailsForm, setAddEditUserDetailsForm] = useState(null);

  const AddUserDetails = async (userId) => {
    setAddUserDetailsModel(true);

    const response = await axios.post(
      `${baseUrl}/payments/EditUserDetail`,
      { userId: userId },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Include access token in headers
        },
      }
    );
    if (response.status === 200 && response.data.exists) {
      setAddEditUserDetailsForm(response.data.details);
      setuserBasicDetail({});
    } else {
      // message.success("This is a new user. Please add their payment details so the system can create them automatically.");
    }
  };
  const AddUserDetailsClose = () => {
    setAddUserDetailsModel(false);
    getUserList(currentPage, limit, sortField, sortOrder, search, filters);
  };

  // Get Suggestion Values
  const [optionSuggestion, setOptionSuggestion] = useState([]);
  const [villageMasterOptions, setVillageMasterOptions] = useState([]);
  const [villageMasterSearching, setVillageMasterSearching] = useState(false);
  const villageTimerRef = useRef(null);
  const [tehsilOptions, setTehsilOptions] = useState([]);
  const [tehsilSearching, setTehsilSearching] = useState(false);
  const tehsilTimerRef = useRef(null);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [districtSearching, setDistrictSearching] = useState(false);
  const districtTimerRef = useRef(null);
  const searchVillageMaster = (q) => {
    clearTimeout(villageTimerRef.current);
    if (!q || q.length < 1) { setVillageMasterOptions([]); setVillageMasterSearching(false); return; }
    setVillageMasterSearching(true);
    villageTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search`, {
          params: { q },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setVillageMasterOptions((res.data.result || []).map(v => {
          const parts = [v.name_en];
          if (v.name_hn) parts.push(v.name_hn);
          const loc = [v.tehsil_en, v.district_en].filter(Boolean).join(', ');
          return { value: v.name_en, label: loc ? `${parts.join(' / ')} — ${loc}` : parts.join(' / ') };
        }));
      } catch { setVillageMasterOptions([]); }
      finally { setVillageMasterSearching(false); }
    }, 300);
  };

  const searchTehsil = (q) => {
    clearTimeout(tehsilTimerRef.current);
    if (!q || q.length < 1) { setTehsilOptions([]); setTehsilSearching(false); return; }
    setTehsilSearching(true);
    tehsilTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search-tehsil`, {
          params: { q },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setTehsilOptions((res.data.result || []).map(v => ({
          value: v.tehsil_en,
          label: `${v.tehsil_en}${v.tehsil_hn ? ' / ' + v.tehsil_hn : ''}`
        })));
      } catch { setTehsilOptions([]); }
      finally { setTehsilSearching(false); }
    }, 300);
  };

  const searchDistrict = (q) => {
    clearTimeout(districtTimerRef.current);
    if (!q || q.length < 1) { setDistrictOptions([]); setDistrictSearching(false); return; }
    setDistrictSearching(true);
    districtTimerRef.current = setTimeout(async () => {
      try {
        const res = await axios.get(`${baseUrl}/village/search-district`, {
          params: { q },
          headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` }
        });
        setDistrictOptions((res.data.result || []).map(v => ({
          value: v.district_en,
          label: `${v.district_en}${v.district_hn ? ' / ' + v.district_hn : ''}`
        })));
      } catch { setDistrictOptions([]); }
      finally { setDistrictSearching(false); }
    }, 300);
  };
  const getPanelValue = async (searchText, columnName, tableName) => {
    if (searchText.length < 3) {
      setOptionSuggestion([]);
      return;
    }

    try {
      const response = await axios.get(
        `${baseUrl}/payments/getSuggestionValue/`,
        {
          params: { q: searchText, column: columnName, table: tableName },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`, // Include access token in headers
          },
        }
      );
      if (response.status === 200) {
        setOptionSuggestion(response.data.result);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const rowClassName = (record) => {
    return record.status === "Inactive" ? "inactive-row" : "";
  };

  const exportToExcel = async () => {
    setLoading(true);
    const sortParam =
      sortField && sortOrder
        ? `&sortField=${sortField}&sortOrder=${sortOrder}`
        : "";
    const searchParam = search ? `&search=${search}` : "";
    const filterParams = Object.keys(filters)
      .map((key) => `${key}=${filters[key]}`)
      .join("&");
    const response = await axios.get(
      `${baseUrl}/users/list?page=${1}&limit=all${sortParam}${searchParam}&${filterParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (response.data.status) {
      setLoading(false);
      const formattedData = response.data.result.map((user, index) => ({
        "Sr.No": index + 1,
        "Phone no": user.phone_no,
        Name: user.name,
        Relation: user.relation,
        "Father Name": user.father_name,
        "Monthly Share": user.announced_amount,
        "DOB Date": user.dob ? moment(user.dob).format("DD-MM-YYYY") : "-",
        "Joining Date": user.joining_date
          ? moment(user.joining_date).format("DD-MM-YYYY")
          : "-",
        "Street/House No": user.per_address,
        "Village/Town": user.per_village,
        Post: user.per_post,
        "Pin-Code": user.per_pin_code,
        "Tahsil/City": user.per_tahsil,
        District: user.per_district,
        State: user.per_state,
        Status: user.status,
        "Photo URL": user.profile_img,
      }));

      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "User List");
      XLSX.writeFile(workbook, "User-List.xlsx");
    } else {
      setLoading(false);
      notification.info({
        message: "Info",
        description: response.data.message,
        placement: "topRight",
      });
    }
  };





// Table columns definition
const columns = [
  {
    title: createStyledTitle("S.No"),
    dataIndex: "key",
    key: "key",
    fixed: "left",
    width: 60,
    render: (text, record) => (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3 }}>
        <span style={{ fontWeight: 600, fontSize: 12, color: '#7a0000' }}>{text}</span>
        <span style={{
          display: 'inline-block',
          width: 8, height: 8, borderRadius: '50%',
          background: record.status === 'Active' ? '#52c41a' : '#ff4d4f',
          boxShadow: record.status === 'Active' ? '0 0 4px #52c41a' : '0 0 4px #ff4d4f',
        }} />
      </div>
    ),
  },
  {
    title: createStyledTitle("Name / Father Name"),
    dataIndex: "name",
    key: "name",
    fixed: "left",
    // sorter: true,
    width: 220,
  },
  {
    title: createStyledTitle("Phone no"),
    dataIndex: "phone_no",
    key: "phone_no",
    // sorter: true,
  },
  {
    title: createStyledTitle("Monthly Share"),
    dataIndex: "announced_amount",
    key: "announced_amount",
    render: (text, user) => {
      let amountStyle = {};
      if (user.announced_amount >= 1000) {
        amountStyle = { color: "green", fontWeight: "bold" }; // High amount
      } else if (user.announced_amount >= 500) {
        amountStyle = { color: "orange" }; // Medium amount
      } else {
        amountStyle = { color: "red" }; // Low amount
      }

      return (
        <div className="author-info">
          <Title level={5} style={amountStyle}>
            {user.announced_amount ? "Rs." + user.announced_amount : "-"}
          </Title>
        </div>
      );
    },
  },

  {
    title: createStyledTitle("DOB Date"),
    dataIndex: "dob",
    key: "dob",
    // sorter: true,
  },
  {
    title: createStyledTitle("Joining Date"),
    dataIndex: "createdAt",
    key: "createdAt",
    // sorter: true,
  },
  // {
  //   title: createStyledTitle("Street/House No"),
  //   dataIndex: "per_address",
  //   key: "per_address",
  //   // sorter: true,
  // },
  {
    title: createStyledTitle("Village / Post"),
    dataIndex: "per_village",
    key: "per_village",
    // sorter: true,
  },
  {
    title: createStyledTitle("Tehsil / Pincode"),
    dataIndex: "per_tahsil",
    key: "per_tahsil",
    // sorter: true,
  },
  {
    title: createStyledTitle("District"),
    dataIndex: "per_district",
    key: "per_district",
    // sorter: true,
  },
  {
    title: createStyledTitle("State"),
    dataIndex: "per_state",
    key: "per_state",
    // sorter: true,
  },

  {
        title: createStyledTitle("Category"),
        dataIndex: "category",
        key: "category",
    },


  {
    title: createStyledTitle("Action"),
    key: "action",
    dataIndex: "action",
    fixed: "right",
  },
];


  const handleUserFilterCheckboxChange = (e) => {
    setShowUserFilter(e.target.checked);
    if (staffList.length === 0) {
      getStaffList();
    }
  };

  const handleView = (id) => {
    history.push({
      pathname: `/users/view/${id}`,
      state: { page: currentPage, limit: limit }, // Pass both page and limit
    });
  };

  const handlePermanentAddressCheckboxChange = (e) => {
    setShowPermanentAddress(e.target.checked);
  };

  const handleTemporaryAddressCheckboxChange = (e) => {
    setShowTemporaryAddress(e.target.checked);
  };

  //For filter set
  const handleSearchReport = () => {
    // Trigger API call with current filters
    getUserList(1, limit, sortField, sortOrder, search, filters);
  };

  // Reset filters and update URL
  const handleResetFilters = () => {
    const resetFilters = {
      name: "",
      email: "",
      phone: "",
      father_name: "",
      gotra: "",
      kuldevi: "",
      kulrishi: "",
      alternate_phone_no: "",
      alternate_phone_no2: "",
      dob: "",
      joining_date: "",
      category: "",
      min_monthly_amount: "",
      max_monthly_amount: "",
      status: "",
      maritial_status: "",
      relation_hn: "",
      per_village_en: [],
      per_post_en: "",
      per_tahsil_en: [],
      per_pin_code_en: "",
      per_district_en: [],
      per_state_en: "",
      per_country_en: "",

      txn_tem_address_en: "",
      tem_village_en: "",
      tem_street_en: "",
      tem_city_en: "",
      tem_pin_code_en: "",
      tem_district_en: "",
      tem_state_en: "",
      tem_country_en: "",
    };

    setFilters(resetFilters);

    // Update URL with empty filters
    const updatedQueryParams = new URLSearchParams(location.search);
    Object.keys(resetFilters).forEach((key) => {
      updatedQueryParams.delete(key); // Remove all filters from URL
    });
    history.push(`?${updatedQueryParams.toString()}`);

    // Optionally trigger a reset search
    getUserList(1, limit, sortField, sortOrder, search, resetFilters);
  };

  return (
    <>
      {loading && (
        <div className="full-page-loader">
          <Spin size="large" />
        </div>
      )}
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>Members</span>}
              headStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0', padding: '5px 16px' }}
              extra={
                <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                  {(() => {
                    const btnStyle = {
                      background: '#fff',
                      borderColor: '#7a0000',
                      color: '#7a0000',
                      fontWeight: 600,
                      fontSize: 12,
                      height: 28,
                      padding: '0 10px',
                      lineHeight: '26px',
                      borderRadius: 5,
                    };
                    return (
                      <>
                        {hasPermission("/payments/add_user_payment", "createPermission") && (
                          <Tooltip title="Add New Payment">
                            <Link to="/payments/add_user_payment" style={{ display: 'inline-flex', alignItems: 'center', gap: 4, height: 28, padding: '0 10px', fontSize: 12, borderRadius: 5, background: '#fff', color: '#7a0000', border: '1px solid #7a0000', fontWeight: 600, textDecoration: 'none' }}>
                              <PlusCircleOutlined /> Add Payment
                            </Link>
                          </Tooltip>
                        )}
                        {hasPermission("/users", "downloadPermission") && (
                          <Tooltip title="Download Excel">
                            <Button icon={<FileExcelOutlined />} onClick={exportToExcel} style={btnStyle}>Excel</Button>
                          </Tooltip>
                        )}
                        {hasPermission("/village", "readPermission") && (
                          <Tooltip title="Village Directory">
                            <Link to="/village">
                              <Button icon={<EnvironmentOutlined />} style={btnStyle}>Village Dir.</Button>
                            </Link>
                          </Tooltip>
                        )}
                      </>
                    );
                  })()}
                </div>
              }
            >
              <div className="table-responsive">
                <Table
                  columns={columns}
                  rowClassName={rowClassName}
                  // pagination={false}
                  scroll={{ x: "max-content" }}
                  bordered
                  title={() => (
                    <div style={{ width: '100%' }}>
                      <Row gutter={[10, 10]}>
                        {/* ── Filter Panel ── */}
                        <Col xs={24}>
                          <div style={{ background: '#fff', padding: '10px 12px', borderRadius: 4, border: '1px solid #e8e8e8', marginBottom: 8 }}>

                            {/* Main filters — 4×6 = 24 */}
                            <Row gutter={[8, 8]}>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Phone</label>
                                <Input value={filters.phone} onChange={e => handleFilterChange('phone', e.target.value, 'debounced')} placeholder="Phone number" allowClear style={{ width: '100%' }} />
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Name</label>
                                <Input value={filters.name} onChange={e => handleFilterChange('name', e.target.value, 'debounced')} placeholder="Name / नाम" allowClear style={{ width: '100%' }} />
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Village</label>
                                <Select
                                  mode="multiple" showSearch filterOption={false}
                                  placeholder="Village/Town"
                                  value={filters.per_village_en || []}
                                  options={villageMasterOptions}
                                  onSearch={searchVillageMaster}
                                  onChange={values => handleFilterChange('per_village_en', values)}
                                  loading={villageMasterSearching}
                                  notFoundContent={villageMasterSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search (master + existing data)</span>}
                                  allowClear maxTagCount={1} maxTagTextLength={10}
                                  style={{ width: '100%' }}
                                />
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Tehsil</label>
                                <Select mode="multiple" showSearch filterOption={false} placeholder="Tehsil" value={filters.per_tahsil_en || []} options={tehsilOptions} onSearch={searchTehsil} onChange={values => handleFilterChange('per_tahsil_en', values)} loading={tehsilSearching} notFoundContent={tehsilSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search (master + existing data)</span>} allowClear maxTagCount={1} maxTagTextLength={10} style={{ width: '100%' }} />
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>District</label>
                                <Select mode="multiple" showSearch filterOption={false} placeholder="District" value={filters.per_district_en || []} options={districtOptions} onSearch={searchDistrict} onChange={values => handleFilterChange('per_district_en', values)} loading={districtSearching} notFoundContent={districtSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search (master + existing data)</span>} allowClear maxTagCount={1} maxTagTextLength={10} style={{ width: '100%' }} />
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Status</label>
                                <Select style={{ width: '100%' }} placeholder="Status" value={filters.status || undefined} onChange={value => handleFilterChange('status', value, true)} allowClear>
                                  <Option value="Active">Active</Option>
                                  <Option value="Inactive">Inactive</Option>
                                </Select>
                              </Col>
                              <Col xs={24} sm={12} md={8} lg={4}>
                                <label style={labelStyle}>Mission 21K</label>
                                <Select style={{ width: '100%' }} placeholder="All Members" value={filters.campaign || undefined} onChange={value => handleFilterChange('campaign', value, true)} allowClear>
                                  <Option value="mission_21k">🎯 Mission 21K सदस्य</Option>
                                </Select>
                              </Col>
                            </Row>

                            {/* Button row */}
                            <div style={{ display: 'flex', gap: 8, marginTop: 8, alignItems: 'center' }}>
                              <Button icon={<SearchOutlined />} onClick={handleSearchReport} style={{ background: '#7a0000', borderColor: '#7a0000', color: '#fff', fontWeight: 600, minWidth: 100 }}>Search</Button>
                              <Button onClick={handleResetFilters} style={{ minWidth: 80 }}>Reset</Button>
                              <Button onClick={() => setShowAdvancedFilters(!showAdvancedFilters)} style={{ background: showAdvancedFilters ? '#7a0000' : '#f0f3f7', borderColor: '#7a0000', color: showAdvancedFilters ? '#fff' : '#7a0000', fontWeight: 600 }}>
                                {showAdvancedFilters ? '▲ Less Filters' : '▼ More Filters'}
                              </Button>
                            </div>

                            {/* Additional filters (hidden by default) */}
                            {showAdvancedFilters && (
                              <div style={{ marginTop: 10, background: '#f8f9fa', borderRadius: 6, border: '1px solid #e0e6ee', padding: '10px 12px' }}>
                                <div style={{ fontSize: 11, color: '#7a0000', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 8 }}>Additional Filters</div>
                                <Row gutter={[10, 10]}>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Relation</label>
                                    <Select style={{ width: '100%' }} placeholder="Relation" value={filters.relation_hn || undefined} onChange={value => handleFilterChange('relation_hn', value, true)} allowClear>
                                      <Option value="सुपुत्र श्री">सुपुत्र श्री</Option>
                                      <Option value="सुपुत्री श्री">सुपुत्री श्री</Option>
                                      <Option value="पत्नी श्री">पत्नी श्री</Option>
                                      <Option value="गोद पुत्र श्री">गोद पुत्र श्री</Option>
                                      <Option value="शिष्य श्री">शिष्य श्री</Option>
                                    </Select>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Email</label>
                                    <Input value={filters.email} onChange={e => handleFilterChange('email', e.target.value)} placeholder="Email" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Father Name</label>
                                    <Input value={filters.father_name} onChange={e => handleFilterChange('father_name', e.target.value)} placeholder="Father Name/पिता का नाम" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Gotra</label>
                                    <Input value={filters.gotra} onChange={e => handleFilterChange('gotra', e.target.value)} placeholder="Gotra" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Kuldevi</label>
                                    <Input value={filters.kuldevi} onChange={e => handleFilterChange('kuldevi', e.target.value)} placeholder="Kuldevi" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Kulrishi</label>
                                    <Input value={filters.kulrishi} onChange={e => handleFilterChange('kulrishi', e.target.value)} placeholder="Kulrishi" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Alt 1 No.</label>
                                    <Input value={filters.alternate_phone_no} onChange={e => handleFilterChange('alternate_phone_no', e.target.value)} placeholder="Alt 1 No." style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Alt 2 No.</label>
                                    <Input value={filters.alternate_phone_no2} onChange={e => handleFilterChange('alternate_phone_no2', e.target.value)} placeholder="Alt 2 No." style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Date of Birth</label>
                                    <DatePicker className="filter_dob" format="DD-MM-YYYY" value={filters.dob ? moment(filters.dob, 'DD-MM-YYYY') : null} onChange={(_, dateString) => handleFilterChange('dob', dateString)} placeholder="DOB" style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Joining Date</label>
                                    <DatePicker className="filter_dob" format="DD-MM-YYYY" value={filters.joining_date ? moment(filters.joining_date, 'DD-MM-YYYY') : null} onChange={(_, dateString) => handleFilterChange('joining_date', dateString)} placeholder="Joining Date" style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Marital Status</label>
                                    <Select style={{ width: '100%' }} placeholder="Marital" value={filters.maritial_status || undefined} onChange={value => handleFilterChange('maritial_status', value, true)} allowClear>
                                      <Option value="Married">Married</Option>
                                      <Option value="UnMarried">UnMarried</Option>
                                      <Option value="Widowed">Widowed</Option>
                                    </Select>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={3}>
                                    <label style={labelStyle}>Category</label>
                                    <Input value={filters.category} onChange={e => handleFilterChange('category', e.target.value)} placeholder="Category" style={{ width: '100%' }} allowClear />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={5}>
                                    <label style={labelStyle}>Monthly Share Range</label>
                                    <div style={{ display: 'flex', gap: 4 }}>
                                      <Input placeholder="Min" value={filters.min_monthly_amount} onChange={e => handleFilterChange('min_monthly_amount', e.target.value)} style={{ flex: 1 }} />
                                      <Input placeholder="Max" value={filters.max_monthly_amount} onChange={e => handleFilterChange('max_monthly_amount', e.target.value)} style={{ flex: 1 }} />
                                    </div>
                                  </Col>

                                  {/* Permanent Address */}
                                  <Col xs={24}>
                                    <div style={{ fontSize: 11, color: '#7a0000', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, borderTop: '1px solid #e0e6ee', paddingTop: 8, marginTop: 4 }}>Permanent Address</div>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Village/Town</label>
                                    <Select
                                      mode="multiple"
                                      showSearch
                                      filterOption={false}
                                      placeholder="Village/Town (multi-select)"
                                      value={filters.per_village_en || []}
                                      options={villageMasterOptions}
                                      onSearch={searchVillageMaster}
                                      onChange={values => handleFilterChange('per_village_en', values)}
                                      loading={villageMasterSearching}
                                      notFoundContent={villageMasterSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search master or press Enter to add</span>}
                                      allowClear
                                      style={{ width: '100%' }}
                                    />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Post</label>
                                    <AutoComplete value={filters.per_post_en} placeholder="Post" options={optionSuggestion} onChange={value => handleFilterChange('per_post_en', value)} onSearch={text => getPanelValue(text, 'per_post_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Tehsil</label>
                                    <Select mode="multiple" showSearch filterOption={false} placeholder="Tehsil (multi)" value={filters.per_tahsil_en || []} options={tehsilOptions} onSearch={searchTehsil} onChange={values => handleFilterChange('per_tahsil_en', values)} loading={tehsilSearching} notFoundContent={tehsilSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search (master + existing data)</span>} allowClear style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>District</label>
                                    <Select mode="multiple" showSearch filterOption={false} placeholder="District (multi)" value={filters.per_district_en || []} options={districtOptions} onSearch={searchDistrict} onChange={values => handleFilterChange('per_district_en', values)} loading={districtSearching} notFoundContent={districtSearching ? <Spin size="small" /> : <span style={{fontSize:12,color:'#999'}}>Type to search (master + existing data)</span>} allowClear style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>State</label>
                                    <AutoComplete value={filters.per_state_en} placeholder="State" options={optionSuggestion} onChange={value => handleFilterChange('per_state_en', value)} onSearch={text => getPanelValue(text, 'per_state_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Pin Code</label>
                                    <AutoComplete value={filters.per_pin_code_en} placeholder="Pin Code" options={optionSuggestion} onChange={value => handleFilterChange('per_pin_code_en', value)} onSearch={text => getPanelValue(text, 'per_pin_code_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>

                                  {/* Temporary Address */}
                                  <Col xs={24}>
                                    <div style={{ fontSize: 11, color: '#7a0000', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5, borderTop: '1px solid #e0e6ee', paddingTop: 8, marginTop: 4 }}>Temporary Address</div>
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>Village/Town</label>
                                    <AutoComplete value={filters.tem_village_en} placeholder="Village/Town" options={optionSuggestion} onChange={value => handleFilterChange('tem_village_en', value)} onSearch={text => getPanelValue(text, 'tem_village_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>City</label>
                                    <AutoComplete value={filters.tem_city_en} placeholder="City" options={optionSuggestion} onChange={value => handleFilterChange('tem_city_en', value)} onSearch={text => getPanelValue(text, 'tem_city_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>District</label>
                                    <AutoComplete value={filters.tem_district_en} placeholder="District" options={optionSuggestion} onChange={value => handleFilterChange('tem_district_en', value)} onSearch={text => getPanelValue(text, 'tem_district_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                  <Col xs={24} sm={12} md={6} lg={4}>
                                    <label style={labelStyle}>State</label>
                                    <AutoComplete value={filters.tem_state_en} placeholder="State" options={optionSuggestion} onChange={value => handleFilterChange('tem_state_en', value)} onSearch={text => getPanelValue(text, 'tem_state_en', 'sn_user_address')} style={{ width: '100%' }} />
                                  </Col>
                                </Row>
                              </div>
                            )}

                          </div>
                        </Col>

                        {/* Records per page */}
                        <Col xs={24}>
                          <span style={{ marginRight: 10, fontSize: 13 }}>Records per page:</span>
                          <Select value={limit} onChange={handleLimitChange}>
                            <Option value={20}>20</Option>
                            <Option value={40}>40</Option>
                            <Option value={60}>60</Option>
                            <Option value={80}>80</Option>
                            <Option value={100}>100</Option>
                          </Select>
                        </Col>
                      </Row>
                    </div>
                  )}
                  dataSource={userList.map((user, index) => ({
                    key: limit * (currentPage - 1) + index + 1,
                    user_id: user.user_id,
                    status: user.status,
                    name: (
                      <>
                        <Avatar.Group>
                          <Avatar
                            className="shape-avatar"
                            shape="square"
                            size={40}
                            src={
                              user.profile_img ? user.profile_img : userDummy
                            }
                            icon={!user.profile_img && <UserOutlined />}
                            onClick={() =>
                              showModal(
                                user.profile_img ? user.profile_img : userDummy
                              )
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <div className="avatar-info">
                            <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexWrap: 'wrap', marginBottom: 0 }}>
                              <Title level={5} style={{ marginBottom: 0 }}>
                                <Link to={`/users/view/${user.user_id}`}>
                                  {user.name}
                                </Link>
                              </Title>
                              {/* Multi-account star */}
                              {user.account_count >= 2 && (
                                <Tooltip title={`Contributing to ${user.account_count} accounts`}>
                                  <StarFilled style={{ color: '#faad14', fontSize: 13, cursor: 'default' }} />
                                </Tooltip>
                              )}
                              {/* Loyalty badge */}
                              {(() => {
                                const badge = getLoyaltyBadge(user.years_active);
                                if (!badge) return null;
                                return (
                                  <Tooltip title={badge.title}>
                                    <span style={{
                                      fontSize: 10, fontWeight: 700,
                                      color: badge.color, background: badge.bg,
                                      border: `1px solid ${badge.color}`,
                                      borderRadius: 4, padding: '0px 4px',
                                      cursor: 'default', lineHeight: '16px',
                                    }}>
                                      <TrophyFilled style={{ fontSize: 9, marginRight: 2 }} />
                                      {badge.label}
                                    </span>
                                  </Tooltip>
                                );
                              })()}
                              {/* Mission 21K badge */}
                              {user.campaign === 'mission_21k' && (
                                <Tooltip title={`Mission 21K सदस्य — ₹${user.mission_monthly_amount || 200}/माह • ${user.mission_joined_at ? new Date(user.mission_joined_at).toLocaleDateString('hi-IN') : ''}`}>
                                  <span style={{
                                    fontSize: 10, fontWeight: 800,
                                    color: '#92400e', background: '#fef3c7',
                                    border: '1px solid #f59e0b',
                                    borderRadius: 4, padding: '0px 5px',
                                    cursor: 'default', lineHeight: '16px',
                                  }}>
                                    🎯 21K
                                  </span>
                                </Tooltip>
                              )}
                              {/* Auto-pay subscription badge */}
                              {user.rzp_subscription_status === 'active' && (
                                <Tooltip title="Auto-pay Active — हर माह automatically कटता है">
                                  <span style={{
                                    fontSize: 10, fontWeight: 800,
                                    color: '#15803d', background: '#dcfce7',
                                    border: '1px solid #86efac',
                                    borderRadius: 4, padding: '0px 5px',
                                    cursor: 'default', lineHeight: '16px',
                                  }}>
                                    🔄 Auto
                                  </span>
                                </Tooltip>
                              )}
                              {user.rzp_subscription_status === 'halted' && (
                                <Tooltip title="Auto-pay Halted — payment fail हुआ">
                                  <span style={{
                                    fontSize: 10, fontWeight: 800,
                                    color: '#dc2626', background: '#fef2f2',
                                    border: '1px solid #fca5a5',
                                    borderRadius: 4, padding: '0px 5px',
                                    cursor: 'default', lineHeight: '16px',
                                  }}>
                                    ⚠️ Auto
                                  </span>
                                </Tooltip>
                              )}
                            </div>
                            {(user.relation || user.father_name) && (
                              <p style={{ margin: 0, fontSize: 12, color: '#888' }}>
                                {user.relation ? `${user.relation} ` : ''}{user.father_name || ''}
                              </p>
                            )}
                          </div>
                        </Avatar.Group>{" "}
                      </>
                    ),
                    phone_no: (
                      <>
                        <div className="author-info">
                          <Title
                            level={5}
                            style={{
                              color: "#7a0000",
                              backgroundColor: "#e8f0fe",
                              padding: "4px 8px",
                              borderRadius: "4px",
                            }}
                          >
                            {user.phone_no}
                          </Title>
                          <p>{user.alternate_phone_no}</p>
                        </div>
                      </>
                    ),
                    father_name: (
                      <>
                        <div className="author-info">
                          <Title level={5}> {user.relation}</Title>
                          <p>{user.father_name}</p>
                        </div>
                      </>
                    ),
                    announced_amount: user.announced_amount,
                    dob: (
                      <>
                        <div className="author-info">
                          <Title level={5}>
                            {user.dob
                              ? moment(user.dob).format("DD/MM/YYYY")
                              : "-"}{" "}
                          </Title>
                        </div>
                      </>
                    ),
                    createdAt: (
                      <>
                        <div className="author-info">
                          <Title level={5}>
                            {user.joining_date
                              ? moment(user.joining_date).format("DD MMMM YYYY")
                              : "-"}
                          </Title>
                        </div>
                      </>
                    ),

                    per_address: (
                      <>
                        <div className="author-info">
                          <Title level={5}>
                            {user.per_address ? user.per_address : ""}
                          </Title>
                          <p>{user.tem_address ? user.tem_address : ""}</p>
                        </div>
                      </>
                    ),
                    per_village: (
                      <div className="author-info">
                        <Title level={5} style={{ marginBottom: 0 }}>{user.per_village || '-'}</Title>
                        {user.per_post && <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{user.per_post}</p>}
                      </div>
                    ),
                    per_tahsil: (
                      <div className="author-info">
                        <Title level={5} style={{ marginBottom: 0 }}>{user.per_tahsil || '-'}</Title>
                        {user.per_pin_code && <p style={{ margin: 0, fontSize: 12, color: '#888' }}>{user.per_pin_code}</p>}
                      </div>
                    ),
                    per_district: (
                      <>
                        <div className="author-info">
                          <Title level={5}>{user.per_district}</Title>
                          <p>{user.tem_district}</p>
                        </div>
                      </>
                    ),
                    per_state: (
                      <>
                        <div className="author-info">
                          <Title level={5}>{user.per_state}</Title>
                          <p>{user.tem_state}</p>
                        </div>
                      </>
                    ),

                     category: (
                      <>
                        <div className="author-info">
                          <Title level={5}>{user.category || '-'}</Title>
                          
                        </div>
                      </>
                    ),

                    status: user.status,
                    action: (
                      <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap', alignItems: 'center' }}>
                        {/* Permanently Deactivated badge */}
                        {user.is_delete === '1' || user.is_delete === 1 ? (
                          <>
                            <span style={{
                              display: 'inline-flex', alignItems: 'center', gap: 4,
                              padding: '4px 10px', background: '#fff1f0',
                              color: '#a8071a', border: '1.5px solid #ffa39e',
                              borderRadius: 5, fontSize: 11, fontWeight: 700,
                            }}>
                              🚫 Permanently Deactivated
                            </span>
                            {hasPermission("/users", "readPermission") && (
                              <button
                                onClick={() => handleView(user.user_id)}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#1677ff', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                <EyeOutlined style={{ fontSize: 11 }} /> View
                              </button>
                            )}
                          </>
                        ) : (
                          <>
                            {hasPermission("/users", "editPermission") && (
                              <button
                                onClick={() => AddUserDetails(user.user_id)}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#7a0000', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                <EditOutlined style={{ fontSize: 11 }} /> Edit
                              </button>
                            )}
                            {hasPermission("/users", "readPermission") && (
                              <button
                                onClick={() => handleView(user.user_id)}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#1677ff', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                <EyeOutlined style={{ fontSize: 11 }} /> View
                              </button>
                            )}
                            {hasPermission("/users", "editPermission") && (
                              <button
                                onClick={() => handleToggleBlockMsg(user.user_id, user.block_msg)}
                                title={user.block_msg ? "Unblock messaging" : "Block all messages"}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: user.block_msg ? '#fa8c16' : '#8c8c8c', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                {user.block_msg ? <><CheckCircleOutlined style={{ fontSize: 11 }} /> Unblock</> : <><StopOutlined style={{ fontSize: 11 }} /> Block Msg</>}
                              </button>
                            )}
                            {hasPermission("/users", "editPermission") && (
                              <Tooltip title={user.hide_from_leaderboard ? 'Leaderboard में दिखाएं' : 'Leaderboard से छिपाएं'}>
                                <button
                                  onClick={() => handleToggleLeaderboard(user.user_id, user.hide_from_leaderboard)}
                                  style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: user.hide_from_leaderboard ? '#faad14' : '#52c41a', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                                >
                                  {user.hide_from_leaderboard ? '👁 Show' : '🏆 Hide'}
                                </button>
                              </Tooltip>
                            )}
                            {hasPermission("/users", "deletePermission") && (
                              <button
                                onClick={() => showPermanentDeleteConfirm(user.user_id, user.name || user.name_eng || '')}
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#ff4d4f', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                <DeleteOutlined style={{ fontSize: 11 }} /> Delete
                              </button>
                            )}
                            {hasPermission("/users", "editPermission") && user.parent_id && (
                              <button
                                onClick={() => handleDetachParent(user.user_id, user.name || '')}
                                title="Remove wrong parent link and make standalone member"
                                style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: '4px 10px', background: '#fa8c16', color: '#fff', border: 'none', borderRadius: 5, fontSize: 12, fontWeight: 600, cursor: 'pointer' }}
                              >
                                Make Parent
                              </button>
                            )}
                          </>
                        )}
                      </div>
                    ),
                  }))}
                  pagination={{
                    ...pagination,
                    showTotal: (total) => `Total ${total} records`,
                    style: { marginRight: 20 },
                  }}
                  onChange={handleTableChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>

        <Modal open={isModalVisible} footer={null} onCancel={handleCancel}>
          <img src={currentImage} alt="Profile" style={{ width: "100%" }} />
        </Modal>

        <Drawer
          title={<span style={{ color: '#1e293b', fontWeight: 700, fontSize: 15 }}>My Account</span>}
          headerStyle={{ background: '#f8fafc', borderBottom: '1.5px solid #e2e8f0'}}
          closeIcon={<span style={{ color: '#1e293b', fontSize: 18 }}>✕</span>}
          width={1200}
          onClose={AddUserDetailsClose}
          open={AddUserDetailsFormModel}
          styles={{
            body: {
              padding: '4px 16px 40px',
            },
          }}
          maskClosable={true}
        >
          <AddUserDetailsModel
            userData={AddEditUserDetailsForm}
            userBasicDetail={userBasicDetail}
            primaryId=""
            onIdChange=""
          />
        </Drawer>
      </div>
    </>
  );
}

export default UsersList;

